import {useSelector} from "react-redux";
import {getProgress} from "./progress-slice";

export function useProgress({type, id}) {
  return useSelector(getProgress(type, id));
}
